import * as types from './mutation-types'

export default {
  [types.UPDATE_LIST] (state, { data }) {
    state.data = state.data.concat(data)
  }
}



// WEBPACK FOOTER //
// ./src/store/news/mutations.js